import { render, staticRenderFns } from "./TakeNoteInput.vue?vue&type=template&id=e71c68ec"
import script from "./TakeNoteInput.vue?vue&type=script&lang=js"
export * from "./TakeNoteInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports